import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import {  NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
// ReSharper disable InconsistentNaming

export namespace Measures {
    export function sortOptions(): Array<{ key: string, value: string }> {
        const options = new Array<{ key: string, value: string }>();
        options.push({ key: "A", value: "Alphabetical" });
        options.push({ key: "MC", value: "Measure Code" });
        options.push({ key: "P", value: "Performance %" });
        return options;
    }

    export interface IMeasure {
        measureId: number;
        measureName: string;
        measureCode: string;
        programs: string;
        programIds: string;
        noOfPatients: number;
        noOfProviders: number;
        noOfPractices: number;
        noOfOrganizations: number;
        userId: number;
        exclusions: number;
        measureCompletion: number;
        performance: number;
        totalItems: number;
        inRuleId: string;
    }

    export interface IMeasureParticipant {
        measureId: number;
        measureName: string;
        measureIdentifier: string;
        measureCode: string;
        patientId: number;
        clientId: number;
        patientName: string;
        patientMrn: string;
        reportingYear: string;
        programs: string;
        programIds: string;
        status: string;
        measureCompletion: boolean;
        dateOfService?: Date;
        providerId: number;
        OrganizationId: number;
        providerName: string;
        providerNpi: string;
        practiceId: number;
        practiceName: string;
        practiceNpi: string;
        totalItems: number;
        collapsed: boolean;
        show: boolean;
        active: boolean;
        appointmentId: number;
        inRuleId: string;
        flag: boolean;
        contractId: number;
        comments: string;
    }

    export interface IMeasureDecision {
        appointmentId: number;
        clientId: number;
        organizationId: number;
        practiceId: number;
        providerId: number;
        patientId: number;
        measureId: number;
        createdBy:number;
        modifiedBy:number;
        createdDate:Date;
        userName:string;
        isModified:boolean;
        modifiedDate:Date;
        measurementStartDate: Date;
        measurementEndDate: Date;
        statusId: number;
        statusName: string;
        qaJson: string;
        processedDate: string;
    }

    export interface IDecision {
        Answer: string;
        QuestionId: number;
        ValidAnswers: Array<string>;
        QuestionText: string;
        Results: Array<Results>;
    }

    export class Results {
      ResultID: string;
      Prompt: string;
      Type: string;
      Value: string;
      DateValue?: NgbDateStruct;
      ValidationText: string;
      Maxlength: string;
      TimeValue: NgbTimeStruct;
      srno: number;
      Required?: string;
  }
 

    export class Filters {
        userId?: number = null;
        clientId?: number = null;
        organizationId?: number = null;
        practiceId?: number = null;
        providerId?: number = null;
        measureId?: number = null;
        measureName = "";
        measureCode = "";
        contractId?: number = null;
        contractNameFlag: boolean = false;
        sortBy = "MC";
        listTypeId: number = 0;
    }

    export interface IMeasureParticipantProviders {
        reportingYear: string;
        providerId: number;
        practiceId: number;
        clientId: number;
        clientName: string;
        providerName: string;
        npi: string;
        assignedContractTags: string;
        assignedContractIds: string;
        careGaps: string;
        completedMeasures: number;
        totalMeasures: number;
        measureCompletion: number;
        totalItems: number;
    }

    export interface IMeasureParticipantPractices {
        clientId: number;
        clientName: string;
        practiceId: number;
        practiceName: string;
        tin: string;
        assignedContractTags: string;
        assignedContractIds: string;
        eligible: number;
        inComplete: number;
        notMet: number;
        performance: number;
        completion: number;
        totalItems: number;
    }
}
// ReSharper restore InconsistentNaming
